module.exports = __webpack_public_path__ + "media/images/emblems/Haefelfingen-coat_of_arms-6c2ad1f56c986b00df21af862d859bf8.png";